// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KlrOe","importantInfo":"styles_importantInfo__2gzRt"};